import * as React from 'react'

import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

type QuantityInputProps = React.ComponentProps<'input'> & {
    /** Đơn vị hiển thị mờ bên phải trong ô (kg, gói, hộp…). Rỗng = ẩn hậu tố. */
    unit?: string | null
}

/**
 * Ô nhập số lượng có hậu tố đơn vị mờ nằm bên trong, sát mép phải.
 * Khi không có `unit`, render y hệt `<Input>` để không đổi layout chỗ cũ.
 * React 19 nên `ref` của react-hook-form vẫn xuyên qua props tới `<input>`.
 */
function QuantityInput({ unit, className, ...props }: QuantityInputProps) {
    if (!unit) return <Input className={className} {...props} />
    return (
        <div className="relative w-full min-w-0">
            <Input className={cn('pr-12', className)} {...props} />
            <span
                aria-hidden
                className="text-muted-foreground pointer-events-none absolute inset-y-0 right-2.5 flex items-center text-xs"
            >
                {unit}
            </span>
        </div>
    )
}

export { QuantityInput }
